module.exports = {
    calculate: function (bonuses, list) {
        for (var i = 0; i < list.length; i++) {
            switch (list[i].id) {
                // Damage reduction.
                case 36:
                    bonuses.dr += list[i].value;
                    break;

                // Gold find.
                case 79:
                case 239:
                    bonuses.gf += list[i].value;
                    break;

                // Magic find.
                case 80:
                case 240:
                    bonuses.mf += list[i].value;
                    break;

                // Faster attack speed.
                case 93:
                    bonuses.ias += list[i].value;
                    break;

                // Faster hit recovery.
                case 99:
                    bonuses.fhr += list[i].value;
                    break;

                // Faster run/walk.
                case 96:
                    bonuses.frw += list[i].value;
                    break;

                // Faster cast rate.
                case 105:
                    bonuses.fcr += list[i].value;
                    break;

                // Deadly strike.
                case 141:
                case 250:
                    bonuses.ds += list[i].value;
                    break;

                // Crushing blow.
                case 136:
                    bonuses.cb += list[i].value;
                    break;

                // Life leech.
                case 60:
                    bonuses.ll += list[i].value;
                    break;

                // Mana leech.
                case 62:
                    bonuses.ml += list[i].value;
                    break;

                default:
                    break;
            }
        }

        return bonuses;
    }
};



// WEBPACK FOOTER //
// ./src/lib/bonus-calculator.js